<script setup>
import { Tooltip } from "floating-vue";
import "floating-vue/dist/style.css";
defineProps({
  text: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
    <div class="flex">
        <Tooltip
            :triggers="['hover', 'click']"
            :hide-triggers="['hover']"
            :distance="10"
            :disabled="disabled"
            v-bind="$attrs"
        >
            <slot />

            <template #popper>
                <div v-html="text" />
                <slot name="popper" />
            </template>
        </Tooltip>
    </div>
</template>

<style>
.v-popper__popper {
  @apply text-slate-500 text-xs;
  max-width: 400px;
}
.v-popper__popper .v-popper__inner {
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  color: #3f3f46;
  background: white;
}
.v-popper__popper .v-popper__arrow-outer {
  border-color: white;
}
</style>
